"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_model_1 = require("prosemirror-model");
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
var orderedmap_1 = __importDefault(require("orderedmap"));
var getSpecFromMap = function (origin) {
    if (origin.nodes instanceof orderedmap_1.default && origin.marks instanceof orderedmap_1.default) {
        var obj_1 = { nodes: {}, marks: {} };
        origin.nodes.forEach(function (name, spec) { return (obj_1.nodes[name] = spec); });
        origin.marks.forEach(function (name, spec) { return (obj_1.marks[name] = spec); });
        return obj_1;
    }
    return origin;
};
// 根据新传入的schema构造新的schema
var updateSchema = function (origin, patches) {
    var newSchema = lodash_clonedeep_1.default(getSpecFromMap(origin));
    patches
        .filter(function (p) { return p && p.name; })
        .reduce(function (res, cur) {
        var name = cur.name;
        var type = cur.getDisplay();
        var spec = res[type];
        spec[name] && console.warn('repeat registration', name);
        spec[name] = cur.config;
        return res;
    }, newSchema);
    return newSchema;
};
exports.updateSchema = updateSchema;
var createSchema = function (schema) { return new prosemirror_model_1.Schema(schema); };
exports.createSchema = createSchema;
//# sourceMappingURL=normalize.js.map